import React from 'react';
import { Text } from 'rebass/styled-components';
import { IBuilderCtrlViewProps } from '../types';

export const ParagraphCtrl: React.FC<IBuilderCtrlViewProps> = ({ properties }) => {
  return (
    <>
      <Text fontWeight={300}>{`${(properties || {}).question || 'Paragraph'}`}</Text>
    </>
  );
};
